<template>
  <div class="supplier-board-container">
    <div class="glow-bg"></div>

    <div class="board-content">
      <header class="board-header">
        <div class="title-wrapper">
          <h1 class="main-title">主要食材供应商公示</h1>
        </div>
        <h2 class="sub-title"></h2>
      </header>

      <main class="board-main">
        <div class="ingredients-list">
          <div class="list-item" v-for="(item, index) in suppliers" :key="index">
            <div class="item-label">{{ item.type_name }}</div>
            <div class="item-value">{{ item.description }}</div>
          </div>
        </div>

        <div class="qr-section">
          <div class="qr-wrapper">
            <!-- <div class="scan-line"></div> -->
            <img :src="qrcode" alt="溯源二维码" class="qr-image" />
            <span class="border-corner top-left"></span>
            <span class="border-corner top-right"></span>
            <span class="border-corner bottom-left"></span>
            <span class="border-corner bottom-right"></span>
          </div>
          <p class="qr-text">扫码溯源 食品安全看得见</p>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
export default {
  name: "SupplierNoticeBoard",
  // 1. 定义 props 接收外部数据
  props: {
    // 接收后端的码 src
    qrcode: {
      type: String,
      default: ""
    },
    // 接收后端的供应商数组
    suppliers: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      // data 里不再需要写死数据了
    };
  }
};
</script>

<style scoped>
/* 容器基础设置：深色背景，居中对齐 */
.supplier-board-container {
  position: relative;
  width: 100%;
  background: #0a192f; /* 深空蓝背景 */
  border-radius: 16px;
  overflow: hidden;
  /* padding: 10px 0px; */
  box-sizing: border-box;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", Arial, sans-serif;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* 增加科技感的环境光背景 */
.glow-bg {
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle at 50% 50%, rgba(64, 158, 255, 0.1) 0%, transparent 60%);
  pointer-events: none;
}

/* 核心内容面板：毛玻璃效果 */
.board-content {
  position: relative;
  width: 100%;
  max-width: 1000px;
  background: rgba(15, 43, 77, 0.6); /* 呼应您原代码中的 #0f2b4d */
  backdrop-filter: blur(12px);
  border: 1px solid rgba(198, 227, 235, 0.2); /* 呼应原代码边框颜色 */
  border-radius: 12px;
  padding: 10px 40px;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
}

/* --- 头部样式 --- */
.board-header {
  text-align: center;
  margin-bottom: 10px;
  border-bottom: 1px dashed rgba(198, 227, 235, 0.3);
  padding-bottom: 10px;
}

.title-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin-bottom: 5px;
}

.main-title {
  font-size: 26px;
  font-weight: bold;
  letter-spacing: 4px;
  margin: 0;
  background: #ffffff;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-shadow: 0 2px 10px rgba(64, 158, 255, 0.3);
}

/* .sub-title {
  font-size: 20px;
  color: #a0cfff;
  letter-spacing: 2px;
  font-weight: 400;
  margin: 0;
} */

/* --- 主体布局：左列表，右二维码 --- */
.board-main {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 40px;
}

/* 左侧：单列网格布局 */
.ingredients-list {
  flex: 1;
  display: grid;
  grid-template-columns: 1fr; /* 这里改为 1fr，表示只有1列并占满全部宽度 */
  gap: 10px; /* 因为变成单列了，水平方向的间距不再需要，可以将 gap 简化为只保留垂直间距 */
}

.list-item {
  display: flex;
  align-items: flex-start;
  font-size: 18px;
  line-height: 1.6;
  padding: 8px 12px;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 6px;
  transition: all 0.3s ease;
}

.list-item:hover {
  background: rgba(64, 158, 255, 0.1);
  transform: translateX(5px);
}

.item-label {
  color: #fff; /* 亮蓝色突出类别 */
  /* font-weight: bold; */
  min-width: 50px;
  /* text-align: justify;
  text-align-last: justify;  */
  margin-right: 15px;
  position: relative;
}

/* .item-label::after {
  content: ":";
  position: absolute;
  right: -10px;
  color: rgba(255, 255, 255, 0.5);
} */

.item-value {
  color: #e6e8eb;
  flex: 1;
}

/* --- 右侧：二维码区域 --- */
.qr-section {
  width: 220px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-left: 40px;
  /* border-left: 1px solid rgba(255, 255, 255, 0.1); */
}

.qr-wrapper {
  position: relative;
  width: 160px;
  height: 160px;
  padding: 10px;
  background: #ffffff;
  border-radius: 8px;
  margin-bottom: 15px;
  box-shadow: 0 0 20px rgba(64, 158, 255, 0.2);
  overflow: hidden;
}

.qr-image {
  width: 100%;
  height: 100%;
  display: block;
}

/* 科技感边角装饰 */
.border-corner {
  position: absolute;
  width: 20px;
  height: 20px;
  border: 3px solid #409EFF;
}
.top-left { top: 0; left: 0; border-right: none; border-bottom: none; border-top-left-radius: 8px;}
.top-right { top: 0; right: 0; border-left: none; border-bottom: none; border-top-right-radius: 8px;}
.bottom-left { bottom: 0; left: 0; border-right: none; border-top: none; border-bottom-left-radius: 8px;}
.bottom-right { bottom: 0; right: 0; border-left: none; border-top: none; border-bottom-right-radius: 8px;}

/* 扫描线动画 */
/* .scan-line {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: #409EFF;
  box-shadow: 0 0 10px #409EFF;
  animation: scan 2.5s infinite linear;
  z-index: 2;
} */

@keyframes scan {
  0% { top: 0; opacity: 0; }
  10% { opacity: 1; }
  90% { opacity: 1; }
  100% { top: 100%; opacity: 0; }
}

.qr-text {
  font-size: 18px;
  color: #fff;
  text-align: center;
  letter-spacing: 1px;
}


/* --- 响应式适配 (移动端或窄屏) --- */
@media (max-width: 900px) {
  .board-main {
    flex-direction: column;
    gap: 30px;
  }
  
  .qr-section {
    width: 100%;
    padding-left: 0;
    border-left: none;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    padding-top: 30px;
  }

  .ingredients-list {
    grid-template-columns: 1fr; /* 窄屏时变为单列 */
  }
}

@media (max-width: 600px) {
  .supplier-board-container {
    padding: 15px;
  }
  .main-title {
    font-size: 24px;
  }
  .restaurant-name {
    font-size: 18px;
  }
}
</style>